// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2ySin","header":"MergedInvoice_header__w8pIf"};